import React, { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

import ClaimStepContainer, { ClaimStepContainerProps } from './ClaimStepContainer';
import container from '../../../../container';
import QueryResult from '../../../common2/QueryResult';
import { ClaimContext } from '../types';
import { createClaimContextFromDraft } from '../../../claims-center/submit-claims/createClaimContext';
import { useClaimsShopSettings } from '../../ClaimsShopSettingsContext';

type Props = ClaimStepContainerProps & {
  shopId: number;
  claim: Pick<ClaimContext, 'draftId' | 'entryPoint'>;
  onChange: (data: Partial<ClaimContext>) => void;
  onDraftLoaded: (context: ClaimContext) => void;
};

function DraftLoadingStep(props: Props) {
  const { shopId, claim, onChange, onNext, onDraftLoaded } = props;
  const { draftId, entryPoint } = claim;

  const shopSettings = useClaimsShopSettings();

  const result = useQuery({
    queryKey: ['claim', draftId],
    queryFn: async () => (draftId ? container.touchpointsApi.getClaim(shopId, draftId) : null),
  });

  useEffect(() => {
    if (result.isFetchedAfterMount && result.data && onNext) {
      const context = createClaimContextFromDraft(entryPoint, result.data, shopSettings);
      onChange(context);
      onDraftLoaded(context);
      onNext({ replace: true, context });
    }
  }, [entryPoint, result, onChange, onNext, onDraftLoaded, shopSettings]);

  return (
    <ClaimStepContainer {...props} onNext={null} onBack={null} onSaveDraft={null}>
      <QueryResult result={result} loadingText="CLAIM_DRAFT_LOADING" />
    </ClaimStepContainer>
  );
}

export default DraftLoadingStep;
